import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const {
  useGet: useGoalAfterGraduation,
  useCreate: useCreateGoalAfterGraduation,
  useUpdate: useUpdateGoalAfterGraduation,
} = getCRUDHooks({
  entityName: 'goalAfterGraduation',
  get: ({ userId, pathId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .goalAfterGraduation.find(),
  create: ({ userId, pathId, values }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .goalAfterGraduation.create(values),
  update: (values, { userId, pathId }) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .paths.id(pathId)
      .goalAfterGraduation.update('', values),
});

export { useGoalAfterGraduation, useCreateGoalAfterGraduation, useUpdateGoalAfterGraduation };
